import { useEffect } from "react";

import tr from "./translations/tr";

export const FINANCE_LANGUAGE_KEY = "financeLanguage";

export const getFinanceLanguage = () => {
    const savedLanguage = localStorage.getItem(
        FINANCE_LANGUAGE_KEY,
    );

    return savedLanguage === "tr"
        ? "tr"
        : "en";
};

export const saveFinanceLanguage = (language) => {
    const nextLanguage =
        language === "tr"
            ? "tr"
            : "en";

    localStorage.setItem(
        FINANCE_LANGUAGE_KEY,
        nextLanguage,
    );

    window.dispatchEvent(
        new CustomEvent(
            "finance-language-change",
            {
                detail: nextLanguage,
            },
        ),
    );

    return nextLanguage;
};

export const financeText = (
    text,
    language = getFinanceLanguage(),
) => {
    if (language !== "tr") {
        return text;
    }

    return tr[text] || text;
};

/*
 * CSS text-transform (uppercase / capitalize) locale-aware olmak için
 * belge diline bakar. Türkçe modda "i" -> "İ" olması için, bu hook
 * yalnızca çağrıldığı sayfa açıkken <html lang> değerini ayarlar ve
 * sayfadan çıkınca eski haline döndürür.
 */
export const useFinanceDocumentLang = (language) => {
    useEffect(() => {
        const root = document.documentElement;
        const previous = root.lang;

        root.lang = language === "tr" ? "tr" : "en";

        return () => {
            root.lang = previous || "en";
        };
    }, [language]);
};

export default {
    getFinanceLanguage,
    saveFinanceLanguage,
    financeText,
};